var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({class:[
    _vm.$style.baseButton,
    ( _obj = {}, _obj[_vm.$style.isBold] = _vm.bold, _obj )
  ],attrs:{"type":_vm.type,"size":_vm.size,"label":_vm.label,"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight,"loading":_vm.loading,"disabled":_vm.disabled,"expanded":_vm.expanded,"rounded":_vm.rounded,"outlined":_vm.outlined,"tag":_vm.tag,"to":_vm.to},on:{"click":_vm.handleClick}},'b-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }